import React from 'react';
import ProductTileCarouselSwiper from './ProductTileCarouselSwiper';
import ProductTileCarouselCSS from './ProductTileCarouselCSS';
const ProductTileCarousel = (props) => {
    return window.PlpTilesCSS ? React.createElement(ProductTileCarouselCSS, Object.assign({}, props)) : React.createElement(ProductTileCarouselSwiper, Object.assign({}, props));
};
export default ProductTileCarousel;
